import classNames from 'classnames';
import { isBoolean, isString, isUndefined } from 'lodash';
import React from 'react';
import { Loading } from '@meitu/saas-ui';
import { BaseViewportPlugin, useGlobalMask, useViewHeight, useViewWidth } from '@/framework';
import { useLocaleStore } from '@/i18n';
import { IExportPlugin, PluginType } from '@/version-types';
import './index.less';

/** 全局遮罩 */
const MaskLoading: React.FC = React.memo(() => {
    const viewWidth = useViewWidth();
    const viewHeight = useViewHeight();
    const globalMask = useGlobalMask();
    const { $t } = useLocaleStore();

    if (!globalMask) return null;

    const backgroundStyle = isString(globalMask.background)
        ? {
              background: globalMask.background,
          }
        : {};

    return (
        <div
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            className={classNames('mask-loading-wrap', {
                'mask-background': isBoolean(globalMask.background) ? globalMask.background : false,
            })}
            style={backgroundStyle}
        >
            <BaseViewportPlugin name="mask-loading">
                <div
                    className={classNames('mask-loading')}
                    style={{
                        transform: `translate(${viewWidth / 2}px, ${viewHeight / 2}px)`,
                    }}
                >
                    {globalMask.loading ? (
                        <Loading
                            style={{ width: 100, height: 100, transform: 'translate(-50%, -50%)' }}
                            tip={isUndefined(globalMask.text) ? $t((v) => v.globalMask.loading) : globalMask.text}
                        />
                    ) : null}
                </div>
            </BaseViewportPlugin>
        </div>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.VIEWPORT,
    sort: 2,
    name: 'mask-loading',
    render() {
        return <MaskLoading />;
    },
};

export default exportPlugin;
